const Backbone  = window.Backbone;

const fs = require('fs');
const path = require('path');
const TitleAuthorTemplate = fs.readFileSync(path.join(__dirname, '../../templates/TitleAuthor.html'), 'utf8');

const TitleAuthor = Backbone.View.extend({
    template: _.template(TitleAuthorTemplate),

    className: 'title-author',

    tagName: 'p',

    initialize() {
        if (this.model.get('type').id !== 'periodicals') {
            this.render();
        }
    },

    render() {
        let title = this.model.toJSON();

        let contents = window.html('cover.noAuthorAvailable');

        if (!_.isEmpty(title.firstCreatorName)) {
            const viewData = {
                href        : window.url(window.routes.searchByType, { type: 'creatorId', query: title.firstCreatorId, sortBy: 'newlyadded' }),
                label   : window.text('cover.searchByAuthor', { author: _.escape(this.model.get('firstCreatorName')) }),
                text        : _.escape(title.firstCreatorName)
            };

            contents = window.text('byLine', { creator: this.template(viewData) });
        }

        this.$el.html(contents);
    }

});

export default TitleAuthor;
